import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { VenuesListFilters, VenuesListResponse } from "./types";
import { VENUES_LIST_QUERY_KEY } from "./constants";
import { buildVenuesQuery } from "./build-venues-query";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. We call `httpClient`
 * directly (body-only contract) rather than the Orval-generated client
 * (which types responses as a `{ data, status, headers }` envelope the
 * mutator doesn't return).
 */
async function fetchVenues(filters: VenuesListFilters): Promise<VenuesListResponse> {
  return httpClient<VenuesListResponse>(`/api/admin/venues${buildVenuesQuery(filters)}`);
}

export function useVenuesList(filters: VenuesListFilters) {
  return useQuery({
    queryKey: [
      ...VENUES_LIST_QUERY_KEY,
      filters.query.trim(),
      filters.status,
      filters.type,
      filters.page,
      filters.limit,
    ] as const,
    queryFn: () => fetchVenues(filters),
    // Keep the previous page on screen while the next loads — no flash
    // of skeleton when paging or typing into the search input.
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });
}
